import * as React from "react";
const SvgFiRrTemperatureList = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-temperature-list_svg__a)">
      <path
        fill="#062147"
        d="M14 1a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1m9 4h-8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2m0 5h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2m-13 7c0 1.654-1.346 3-3 3s-3-1.346-3-3c0-1.302.839-2.402 2-2.816V9a1 1 0 1 1 2 0v5.184c1.161.414 2 1.514 2 2.816m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4-4.889A7 7 0 0 1 14 17c0 3.859-3.141 7-7 7s-7-3.141-7-7c0-1.826.724-3.584 2-4.889V5c0-2.757 2.243-5 5-5s5 2.243 5 5zM12 17a5 5 0 0 0-1.668-3.719 1 1 0 0 1-.332-.744V5c0-1.654-1.346-3-3-3S4 3.346 4 5v7.537a1 1 0 0 1-.332.744A5 5 0 0 0 2 17c0 2.757 2.243 5 5 5s5-2.243 5-5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-temperature-list_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTemperatureList;
